export default __webpack_public_path__ + "static/top-pic-02-df66fa5518970def7dcf996df08a076d.png";